export const slideItems = [
  {
    id: 1,
    img: '/Images/slide1.png',
    title: 'SUMMER SALE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: '#f5fafd',
  },
  {
    id: 2,
    img: '/Images/slide2.png',
    title: 'AUTUMN COLLECTION',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: '#fcf1ed',
  },
  {
    id: 3,
    img: '/Images/slide3.png',
    title: 'POPULAR SALE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: '#fbf0f4',
  },
];

export const categories = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    title: 'SHIRT STYLE!',
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    title: 'LOUNGEWEAR LOVE',
  },
  {
    id: 3,
    img: 'https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    title: 'LIGHT JACKETS',
  },
];

export const popularProducts = [
  {
    id: 1,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728277172/Open%20Source%20assets/SCROLLME/rflmludj3blv5nndmcy8.png',
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728278381/Open%20Source%20assets/SCROLLME/qc4x9dmq4adalzj0guxi.png',
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281397/Open%20Source%20assets/SCROLLME/wg4yk9cv6xbeffbcf9gc.png',
  },
  {
    id: 4,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281764/Open%20Source%20assets/SCROLLME/v8hjwotmxs6a1y6kcfmw.png',
  },
  {
    id: 5,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282159/Open%20Source%20assets/SCROLLME/hbgrx1qxx2zw03mjjsqq.png',
  },
  {
    id: 6,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282694/Open%20Source%20assets/SCROLLME/rasvrtbz0qba8byyrpop.png',
  },
  {
    id: 7,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283401/Open%20Source%20assets/SCROLLME/bilungwnoeaxcbs3f4py.png',
  },
  {
    id: 8,
    img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283881/Open%20Source%20assets/SCROLLME/wae0spbvqlefbbg7vke9.png',
  },
];

export const allProducts = [
  {
    id: 1,
    title: 'Vintage Guitar Tee',
    desc: 'Classic vintage-inspired t-shirt featuring a guitar design.',
    price: '$29.99',
    colors: [
      {
        color: '#050503',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728277172/Open%20Source%20assets/SCROLLME/rflmludj3blv5nndmcy8.png',
      },
      {
        color: '#f5f7fa',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728277224/Open%20Source%20assets/SCROLLME/ubxo8q8biicopd7r7zy0.png',
      },
      {
        color: '#cdcadb',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728277215/Open%20Source%20assets/SCROLLME/brzmyoxp4x1n1mpptsnv.png',
      },
    ],
  },
  {
    id: 2,
    title: 'Comfort Joggers',
    desc: 'Stay comfortable and stylish with these versatile jogger pants.',
    price: '$29.99',
    colors: [
      {
        color: '#ebe4d3',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728278381/Open%20Source%20assets/SCROLLME/qc4x9dmq4adalzj0guxi.png',
      },
      {
        color: '#1c181f',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728278391/Open%20Source%20assets/SCROLLME/rcdop2ulpck4g4pccys2.png',
      },
      {
        color: '#736467',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728278399/Open%20Source%20assets/SCROLLME/gk3e3fcaumzoasw0u2zg.png',
      },
      {
        color: '#161929',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728278405/Open%20Source%20assets/SCROLLME/xkzgdfbdd3gxmdwv3mvm.png',
      },
    ],
  },
  {
    id: 3,
    title: 'Luxury Leather Handbag',
    desc: 'Elevate your style with this exquisite leather handbag from Prada.',
    category: 'Accessories',
    rating: 4.9,
    numRatings: 200,
    price: '$599.99',
    colors: [
      {
        color: '#918369',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281397/Open%20Source%20assets/SCROLLME/wg4yk9cv6xbeffbcf9gc.png',
      },
      {
        color: '#afc7c3',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281397/Open%20Source%20assets/SCROLLME/pqlahatxuh287lq1897l.png',
      },
      {
        color: '#e8c8cc',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281398/Open%20Source%20assets/SCROLLME/zph5momr7kgsimpm4jj9.png',
      },
      {
        color: '#753740',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281398/Open%20Source%20assets/SCROLLME/mfuvwdzqqz2yxcxvzckz.png',
      },
    ],
  },
  {
    colors: [
      { color: '#ebe4d3', img: '' },
      { color: '#1c181f', img: '' },
      { color: '#736467', img: '' },
      { color: '#161929', img: '' },
    ],
  },
  {
    id: 4,
    colors: [
      {
        color: '#291d1d',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281764/Open%20Source%20assets/SCROLLME/v8hjwotmxs6a1y6kcfmw.png',
      },
      {
        color: '#1c181f',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281765/Open%20Source%20assets/SCROLLME/fpbzyytoizcicdmq7apd.png',
      },
      {
        color: '#e6e0cc',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728281764/Open%20Source%20assets/SCROLLME/wr8poapwymgfiyqxmwft.png',
      },
    ],
    title: 'Cozy Sweatshirt',
    desc: 'Perfect for chilly evenings, this cozy sweatshirt is a must-have.',
    category: 'Sweaters',
    rating: 4.7,
    numRatings: 180,
    price: '$49.99',
    discount: '20% off',
    update: 'Last updated 4 days ago',
  },
  {
    id: 5,
    colors: [
      {
        color: '#c0bfde',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282159/Open%20Source%20assets/SCROLLME/hbgrx1qxx2zw03mjjsqq.png',
      },
      {
        color: '#68b5d4',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282157/Open%20Source%20assets/SCROLLME/djayphgosm6pjq3r7rbi.png',
      },
      {
        color: '#428f7d',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282156/Open%20Source%20assets/SCROLLME/pd3ss1554gep4lkjbuuu.png',
      },
    ],
    title: 'Eco-Friendly Tote Bag',
    desc: 'Make a statement with this eco-friendly and stylish tote bag.',
    category: 'Accessories',
    rating: 4.6,
    numRatings: 160,
    price: '$19.99',
    discount: 'Buy 1, Get 1 50% off',
    update: 'Last updated 5 days ago',
  },
  {
    id: 6,
    colors: [
      {
        color: '#cfd1ba',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282694/Open%20Source%20assets/SCROLLME/rasvrtbz0qba8byyrpop.png',
      },
      {
        color: '#1f1f21',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282693/Open%20Source%20assets/SCROLLME/t4tnhtrp2jpmi1icoyej.png',
      },
      {
        color: '#c3c0c4',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282694/Open%20Source%20assets/SCROLLME/n8dmvkkn2rwrinl820gv.png',
      },
      {
        color: '#66666e',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282694/Open%20Source%20assets/SCROLLME/wg6cy1qfasfn9u9ruh2s.png',
      },
      {
        color: '#828999',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282695/Open%20Source%20assets/SCROLLME/f75btoqjmsjl1ubkxi7x.png',
      },
      {
        color: '#a3815d',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728282696/Open%20Source%20assets/SCROLLME/v993dyww51afqs40ttqd.png',
      },
    ],
    title: 'Vintage Chill Cap',
    desc: 'Top off your look with this cool vintage-inspired chill cap.',
    category: 'Accessories',
    rating: 4.8,
    numRatings: 170,
    price: '$24.99',
    discount: '15% off',
    update: 'Last updated 3 days ago',
  },
  {
    id: 7,
    colors: [
      {
        color: '#9fadbd',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283401/Open%20Source%20assets/SCROLLME/bilungwnoeaxcbs3f4py.png',
      },
      {
        color: '#918076',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283401/Open%20Source%20assets/SCROLLME/fl3wnko3q7mllkq9ense.png',
      },
      {
        color: '#1a1617',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283402/Open%20Source%20assets/SCROLLME/wwlw5cg1rivw7lj6lwtk.png',
      },
    ],
    title: 'Short Sleeve Shirt',
    desc: 'Stay casual and comfortable with this stylish short sleeve shirt.',
    category: 'Shirts',
    rating: 4.5,
    numRatings: 140,
    price: '$34.99',
    discount: '10% off',
    update: 'Last updated 6 days ago',
  },
  {
    id: 8,
    colors: [
      {
        color: '#c7c0b1',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283881/Open%20Source%20assets/SCROLLME/wae0spbvqlefbbg7vke9.png',
      },
      {
        color: '#dedcce',
        img: 'https://res.cloudinary.com/dbnticsz8/image/upload/v1728283875/Open%20Source%20assets/SCROLLME/ipuvtesmqpzymjsjmmct.png',
      },
      { color: '#bfa58c', img: 'https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png' },
    ],
    title: "Fashionable Women's Jacket",
    desc: "Step out in style with this fashionable women's jacket.",
    category: 'Jackets',
    rating: 4.9,
    numRatings: 190,
    price: '$79.99',
    discount: 'Free shipping',
    update: 'Last updated 1 day ago',
  },
  {
    id: 9,
    img: 'https://www.pngitem.com/pimgs/m/166-1667033_mens-png-hd-men-png-transparent-png.png',
    title: "Casual Men's Shirt",
    desc: "Upgrade your wardrobe with this comfortable and trendy men's shirt.",
    category: 'Shirts',
    rating: 4.6,
    numRatings: 130,
    price: '$44.99',
    discount: '20% off',
    update: 'Last updated 5 days ago',
  },
];

export const productCategories = ['Shirts', 'Pants', 'Accessories', 'Sweaters', 'Jackets'];
